import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../Admin/Admin.css";

const BASE = "https://dailydish.in/api/admin";

const SchoolOrderManagement = () => {
  const navigate = useNavigate();
  const [schoolHubs, setSchoolHubs] = useState([]);
  const [selectedHub, setSelectedHub] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hubsLoading, setHubsLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchSchoolHubs();
  }, []);

  useEffect(() => {
    if (selectedHub) fetchOrders(selectedHub._id, selectedDate);
  }, [selectedHub, selectedDate]);

  const fetchSchoolHubs = async () => {
    try {
      setHubsLoading(true);
      const res = await axios.get(`${BASE}/getSchoolHubs`);
      if (res.data.success) {
        setSchoolHubs(res.data.hubs);
        if (res.data.hubs.length > 0) setSelectedHub(res.data.hubs[0]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setHubsLoading(false);
    }
  };

  const fetchOrders = async (hubId, date) => {
    try {
      setLoading(true);
      const res = await axios.get(`${BASE}/getSchoolOrders`, {
        params: { hubId, date },
      });
      if (res.data.success) setOrders(res.data.orders);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filtered = orders.filter((o) => {
    const q = search.toLowerCase();
    return (
      !q ||
      (o.studentName || "").toLowerCase().includes(q) ||
      (o.username || "").toLowerCase().includes(q) ||
      (o.counterId || "").toLowerCase().includes(q) ||
      (o.studentClass || "").toLowerCase().includes(q) ||
      (o.studentSection || "").toLowerCase().includes(q)
    );
  });

  const sessionColor = (s) => {
    if (!s) return "#888";
    const sl = s.toLowerCase();
    if (sl === "breakfast") return "#e67e22";
    if (sl === "lunch") return "#2ecc71";
    if (sl === "dinner") return "#3498db";
    return "#888";
  };

  const statusBadge = (status) => {
    const map = {
      Confirmed: "#2ecc71",
      Delivered: "#27ae60",
      Cancelled: "#e74c3c",
      Packing: "#f39c12",
      Packed: "#16a085",
      "On the way": "#8e44ad",
      ontheway: "#8e44ad",
    };
    return map[status] || "#6c757d";
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Inter, sans-serif", background: "#f8f9fa", minHeight: "100vh" }}>
      {/* Header */}
      <div style={{ background: "linear-gradient(135deg, #6B8E23 0%, #4a6e12 100%)", borderRadius: "16px", padding: "24px 28px", color: "#fff", marginBottom: "24px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ fontSize: "36px" }}>🎓</div>
          <div>
            <h2 style={{ margin: 0, fontSize: "22px", fontWeight: "700" }}>School Order Management</h2>
            <p style={{ margin: "4px 0 0", opacity: 0.85, fontSize: "14px" }}>Today's orders across school hubs</p>
          </div>
        </div>
      </div>

      {hubsLoading ? (
        <div style={{ textAlign: "center", padding: "60px", color: "#888" }}>Loading school hubs...</div>
      ) : schoolHubs.length === 0 ? (
        <div style={{ textAlign: "center", padding: "60px", color: "#888" }}>
          <div style={{ fontSize: "48px", marginBottom: "12px" }}>🏫</div>
          <div style={{ fontSize: "16px" }}>No school hubs found. Add a hub with hubType = school first.</div>
        </div>
      ) : (
        <>
          {/* Hub Selector + Date */}
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "20px", alignItems: "center" }}>
            <div style={{ flex: 1, minWidth: "240px" }}>
              <div style={{ fontSize: "12px", color: "#666", fontWeight: "600", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.5px" }}>School Hub</div>
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                {schoolHubs.map((hub) => (
                  <button
                    key={hub._id}
                    onClick={() => setSelectedHub(hub)}
                    style={{
                      padding: "10px 18px",
                      borderRadius: "24px",
                      border: `2px solid ${selectedHub?._id === hub._id ? "#6B8E23" : "#ddd"}`,
                      background: selectedHub?._id === hub._id ? "#6B8E23" : "#fff",
                      color: selectedHub?._id === hub._id ? "#fff" : "#444",
                      fontWeight: "600",
                      fontSize: "13px",
                      cursor: "pointer",
                      transition: "all 0.2s",
                    }}
                  >
                    🏫 {hub.hubName}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <div style={{ fontSize: "12px", color: "#666", fontWeight: "600", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Date</div>
              <input
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                style={{ padding: "10px 14px", borderRadius: "10px", border: "1.5px solid #ddd", fontSize: "14px", fontFamily: "Inter", color: "#333", background: "#fff", cursor: "pointer" }}
              />
            </div>
          </div>

          {/* Stats + Search row */}
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", alignItems: "center", marginBottom: "16px" }}>
            <div style={{ background: "#fff", borderRadius: "12px", padding: "14px 20px", border: "1px solid #e0ebb8", display: "flex", alignItems: "center", gap: "12px", boxShadow: "0 2px 8px rgba(107,142,35,0.08)" }}>
              <div style={{ width: "42px", height: "42px", borderRadius: "12px", background: "linear-gradient(135deg, #6B8E23, #4a6e12)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px" }}>📋</div>
              <div>
                <div style={{ fontSize: "24px", fontWeight: "800", color: "#2c2c2c", lineHeight: 1 }}>{orders.length}</div>
                <div style={{ fontSize: "12px", color: "#888", marginTop: "2px" }}>Total Orders</div>
              </div>
            </div>

            <div style={{ flex: 1, minWidth: "200px" }}>
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search by name, class, counter ID..."
                style={{ width: "100%", padding: "12px 16px", borderRadius: "10px", border: "1.5px solid #ddd", fontSize: "14px", fontFamily: "Inter", boxSizing: "border-box", outline: "none" }}
              />
            </div>

            <button
              onClick={() => navigate("/admin/school-kot", { state: { items: filtered, hubName: selectedHub?.hubName || "", date: selectedDate } })}
              disabled={filtered.length === 0}
              style={{ padding: "12px 20px", borderRadius: "10px", border: "none", background: filtered.length > 0 ? "#6B8E23" : "#ccc", color: "#fff", fontWeight: "700", fontSize: "14px", fontFamily: "Inter", cursor: filtered.length > 0 ? "pointer" : "not-allowed", whiteSpace: "nowrap", display: "flex", alignItems: "center", gap: "6px" }}
            >
              🖨 Print KOT
            </button>
          </div>

          {/* Table */}
          <div style={{ background: "#fff", borderRadius: "16px", overflow: "hidden", boxShadow: "0 2px 12px rgba(0,0,0,0.06)", border: "1px solid #e8f0d8" }}>
            {loading ? (
              <div style={{ textAlign: "center", padding: "60px", color: "#888" }}>Loading orders...</div>
            ) : filtered.length === 0 ? (
              <div style={{ textAlign: "center", padding: "60px", color: "#888" }}>
                <div style={{ fontSize: "40px", marginBottom: "10px" }}>📭</div>
                <div>No orders found for this hub and date.</div>
              </div>
            ) : (
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                  <thead>
                    <tr style={{ background: "linear-gradient(135deg, #f6faf0 0%, #edf5e1 100%)", borderBottom: "2px solid #d4e8b0" }}>
                      {["#", "Counter ID", "Student / Teacher", "Class & Section", "Session", "Status", "Amount", "Time"].map((h) => (
                        <th key={h} style={{ padding: "14px 16px", textAlign: "left", fontWeight: "700", color: "#3a5a0e", fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px", whiteSpace: "nowrap" }}>
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.map((order, idx) => {
                      const isTeacher = !order.studentClass && !order.studentSection;
                      return (
                        <tr
                          key={order._id}
                          style={{ borderBottom: "1px solid #f0f5e8", background: idx % 2 === 0 ? "#fff" : "#fafcf7", transition: "background 0.15s" }}
                          onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f7e6")}
                          onMouseLeave={(e) => (e.currentTarget.style.background = idx % 2 === 0 ? "#fff" : "#fafcf7")}
                        >
                          <td style={{ padding: "12px 16px", color: "#999", fontWeight: "600" }}>{idx + 1}</td>
                          <td style={{ padding: "12px 16px" }}>
                            <span style={{ background: "#e8f4d4", color: "#3a5a0e", borderRadius: "8px", padding: "4px 10px", fontWeight: "700", fontSize: "12px", fontFamily: "monospace" }}>
                              {order.counterId || "—"}
                            </span>
                          </td>
                          <td style={{ padding: "12px 16px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <div style={{ width: "30px", height: "30px", borderRadius: "50%", background: isTeacher ? "#e8f4d4" : "#e8f0ff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", flexShrink: 0 }}>
                                {isTeacher ? "📚" : "🎒"}
                              </div>
                              <div>
                                <div style={{ fontWeight: "600", color: "#2c2c2c" }}>
                                  {order.studentName || order.username || "—"}
                                </div>
                                <div style={{ fontSize: "11px", color: "#888" }}>
                                  {isTeacher ? "Teacher" : "Student"}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: "12px 16px" }}>
                            {order.studentClass || order.studentSection ? (
                              <span style={{ fontSize: "13px", color: "#444" }}>
                                {order.studentClass ? `Class ${order.studentClass}` : ""}
                                {order.studentClass && order.studentSection ? " · " : ""}
                                {order.studentSection ? `Sec ${order.studentSection}` : ""}
                              </span>
                            ) : (
                              <span style={{ color: "#ccc" }}>—</span>
                            )}
                          </td>
                          <td style={{ padding: "12px 16px" }}>
                            <span style={{ background: sessionColor(order.session) + "22", color: sessionColor(order.session), borderRadius: "20px", padding: "3px 10px", fontWeight: "600", fontSize: "12px" }}>
                              {order.session || order.slot || "—"}
                            </span>
                          </td>
                          <td style={{ padding: "12px 16px" }}>
                            <span style={{ background: statusBadge(order.status) + "22", color: statusBadge(order.status), borderRadius: "20px", padding: "3px 10px", fontWeight: "600", fontSize: "12px", whiteSpace: "nowrap" }}>
                              {order.status || "—"}
                            </span>
                          </td>
                          <td style={{ padding: "12px 16px", fontWeight: "600", color: "#2c2c2c" }}>
                            ₹{order.allTotal || 0}
                          </td>
                          <td style={{ padding: "12px 16px", color: "#888", fontSize: "12px", whiteSpace: "nowrap" }}>
                            {order.createdAt
                              ? new Date(order.createdAt).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })
                              : "—"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SchoolOrderManagement;
